module.exports = __webpack_public_path__ + "static/cover-back-1ad9f76d1f47f86c015617b2e4e2ca2b.png";